import { createI18n } from 'vue-i18n'
import ru from './locales/ru.json'
import kk from './locales/kk.json'

const messages = {
  ru,
  kk
}

// Получаем сохраненный язык из localStorage или используем русский по умолчанию
let savedLanguage = 'ru'
try { savedLanguage = localStorage.getItem('language') === 'kk' ? 'kk' : 'ru' } catch { /* Third-party iframe storage may be blocked. */ }

const i18n = createI18n({
  legacy: false,
  locale: savedLanguage,
  fallbackLocale: 'ru',
  messages
})

export default i18n
